module.exports = __webpack_public_path__ + "static/media/event_blue.f06eed52.png";